export class IconHelper {
  private static extractFileType(fileName: string): string {
    const lastDotIndex: number = fileName.lastIndexOf('.');
    if (lastDotIndex < 0) {
      return null;
    }
    return fileName.substring(lastDotIndex);
  }

  static getFileIcon(fileName: string): string {
    const zipIconExtensions: string[] = ['.zip'];
    const pdfIconExtensions: string[] = ['.pdf'];
    const docIconExtensions: string[] = ['.doc', '.docx'];
    const pptIconExtensions: string[] = ['.ppt', '.pptx'];
    const imgIconExtensions: string[] = [
      '.jpg',
      '.jpeg',
      '.png',
      '.eps',
      '.gif',
      '.psd',
      '.ai',
      '.svg',
      '.tif',
      '.tiff',
    ];
    const xlsIconExtensions: string[] = ['.xls', '.xlsx'];
    const txtIconExtensions: string[] = ['.txt'];

    const extension: string = this.extractFileType(fileName);

    switch (true) {
      case zipIconExtensions.includes(extension):
        return 'file-zip';
      case pdfIconExtensions.includes(extension):
        return 'file-pdf';
      case docIconExtensions.includes(extension):
        return 'file-doc';
      case pptIconExtensions.includes(extension):
        return 'file-ppt';
      case imgIconExtensions.includes(extension):
        return 'imfile-age';
      case xlsIconExtensions.includes(extension):
        return 'file-xls';
      case txtIconExtensions.includes(extension):
        return 'file-txt';
      default:
        return 'file-blank';
    }
  }
}
